import React from "react";
import { List } from "../modules/Settings/PackSizes";

export function PackSizesListPage () {
  return <List />;
}
